import { set } from "date-fns";
import React, { useRef, useState } from "react";
import { useOutsideAlerter } from "../../hooks";

export const QIDropdown = ({ toggleComponent, children, className = "", onHide = () => {} }) => {
  const [show, setShow] = useState(false);
  const menuRef = useRef(null);

  useOutsideAlerter(menuRef, () => {
    onHide();
    setShow(false);
  });

  const handleSwitch = () => {
    if (show) {
      onHide();
      setShow(false);
    } else {
      setShow(true);
    }
  };

  const handleKeyDown = (event) => {
    // Handle Enter and Space keys for keyboard accessibility
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault(); // Prevent page scroll on Space
      handleSwitch();
    }
  };

  return (
    <div className={`qi-dropdown qi-form-element ${className} `} ref={menuRef}>
      <div
        className="qi-dropdown_toggle"
        onClick={handleSwitch}
        onKeyDown={handleKeyDown}
        tabIndex={0}
        role="button"
        aria-expanded={show}
        aria-haspopup="true"
      >
        {toggleComponent}
      </div>
      {show && (
        <div className={`qi-dropdown_menu ${show ? "visible" : "invisible"}`}>{children}</div>
      )}
    </div>
  );
};
